'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ODDS_FORMAT_CHANGED = exports.ODDS_FORMAT_CHANGED = '@sb/odds-format-common/ODDS_FORMAT_CHANGED';
var ODDS_FORMATS = exports.ODDS_FORMATS = {
    FRACTION: 'fraction',
    DECIMAL: 'decimal',
    AMERICAN: 'american'
};
var DEFAULT_ODDS_FORMAT = exports.DEFAULT_ODDS_FORMAT = ODDS_FORMATS.FRACTION;
//# sourceMappingURL=constants.js.map